const Backbone = require('backbone');

const model = Backbone.Model.extend({
    idAttribute: 'name',

    defaults: function () {
        return {};
    }
});

module.exports = {
    Model:      model,
    Collection: Backbone.Collection.extend({
        model: model
    })
};
